<template>
  <div class="content">
    <div class="title">
      <div>
        <img src="../../static/images/23@2x.png" alt />
      </div>

      <div>数字化工厂 - {{getTitle}}</div>
      <div class="time">
        <div>{{currentdate}}</div>
        <div>巨细科技技术支持</div>
      </div>
    </div>
    <div class="hightcontent">
      <div class="series">
        <div class="serieslay">
          <div>
            <div>{{getMachineStatusdata.loomCount}}</div>
            <div>总机台数</div>
          </div>
          <div>
            <div>{{getMachineStatusdata.loomAbnormalCount}}</div>
            <div>异常机台</div>
          </div>
          <div style="position:relative">
            <div>{{getMachineStatusdata.loomOpenRate}}%</div>
            <div>
              开机率
              <span
                @mouseover="hovertip2 = true"
                @mouseout="hovertip2 =false"
                class="hovertitle"
              >!</span>
            </div>
            <div class="hovertip" v-if="hovertip2">正常运转机台数/总机台数</div>
          </div>
        </div>
        <div class="serieslay">
          <div>
            <div>{{findEfficiency.rateOfDay}}%</div>
            <div>当日效率</div>
          </div>
          <div>
            <div>{{findEfficiency.rateOfMonth}}%</div>
            <div>本月效率</div>
          </div>
          <div>
            <div>{{findEfficiency.knittingOrders}}</div>
            <div>在织订单</div>
          </div>
        </div>
        <div class="seriesshow">
          <div>
            <div>{{getCallCount.machineRepairCall}}</div>
            <div>
              <div>机修</div>
              <div>呼叫</div>
            </div>
          </div>
          <div>
            <div>{{getCallCount.upperShaftCall}}</div>
            <div>
              <div>上轴</div>
              <div>呼叫</div>
            </div>
          </div>
          <div>
            <div>{{getCallCount.fallingClothCall}}</div>
            <div>
              <div>落布</div>
              <div>呼叫</div>
            </div>
          </div>
        </div>
        <div class="serieslay">
          <div>
            <div>{{todayYield || '0'}}</div>
            <div>当日产量</div>
          </div>
          <div style="position:relative">
            <div>{{thisMontyYield}}</div>
            <div>本月(万米)</div>
            <div class="hovertip" v-if="hovertip3">数据测算最大理论月产能</div>
          </div>
          <div style="cursor: pointer" @mouseover="hovertip3 = true" @mouseout="hovertip3 =false">
            <div>{{monthlyCapacity || '0'}}</div>
            <div>
              月产能(万米)
              <!-- <span @mouseover="hovertip3 = true" @mouseout="hovertip3 =false" class="hovertitle">!</span> -->
            </div>
          </div>
        </div>
      </div>
      <div class="chartstop">
        <div class="qureleft">
          <div>
            <div>当日机台效率区间</div>
            <div class="cerclecanvans">
              <div v-for="(item,index) in efficiencyGroup.loomDayRate" :key="index">
                <div>
                  <el-progress
                    type="circle"
                    :percentage="(item/(efficiencyGroup.sumLoomDownCount==0?1:efficiencyGroup.sumLoomDownCount)*100)"
                    :stroke-width="6"
                    :width="100"
                    :show-text="false"
                    color="#FF106E"
                  ></el-progress>
                  <div class="el-progress__text">
                    <div>{{item}}</div>
                    <div class="nametip" style="display:block">台</div>
                  </div>
                </div>
                <div>{{percendata[index]}}</div>
              </div>
            </div>
          </div>
          <div>
            <div>当月了机预测</div>
            <div class="daylay">
              <div>
                <div v-for="(temp,index) in week" :key="index">{{temp}}</div>
              </div>
              <div>
                <div
                  v-for="(tag,index) in Laydata"
                  :key="index"
                  :style="tag.endTime == todaynum && tag.endNum !='last'?'background:#FF106E;color:white;':''"
                  :class="Laydata.length>35?'hight36':''"
                >
                  <div :style="tag.endNum == 'last'?'color:#464C81':''">{{tag.endTime}}</div>
                  <span
                    class="detailsnum"
                    v-if="tag.endNum !='last' && tag.endNum !=0"
                    :style="tag.endTime == todaynum && tag.endNum !='last'?'background:white;color:#2890FD':''"
                  >{{tag.endNum}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="qureright">
          <div class="qureright-top">
            <div>
              <div class="chartslength-title2">
                <div>近15日效率趋势</div>
                <div></div>
              </div>
              <div id="myChart5" :style="{height: '270px',margin:'-36px 0 0 0'}"></div>
            </div>
            <div>
              <div class="chartslength-title2">
                <div>近15日产量趋势</div>
                <div class="nametip">单位：万米</div>
              </div>
              <div id="myChart6" :style="{height: '270px',margin:'-36px 0 0 0'}"></div>
            </div>
          </div>
          <div class="qureright-center">
            <div>
              <div class="chartslength-title2">
                <div>当班员工效率排名</div>
                <div></div>
              </div>
              <div id="myChart8" :style="{height: '270px',margin:'-40px 0 0 0'}"></div>
            </div>
            <div>
              <div class="chartslength">
                <div class="chartslength-title" style="margin-bottom:15px;">
                  <div>当日品种产量</div>
                  <div class="nametip">单位：米</div>
                </div>
                <div class="lengthitem" style="height:180px;overflow:hidden">
                  <div class="scrollbetter">
                    <div v-for="(item,i) in todayYieldOfVariety" :key="i">
                      <div>
                        <div class="nametip">{{item.name}}</div>
                        <div>{{item.yield}}</div>
                      </div>
                      <div class="longlength">
                        <div :style="{width:(item.yield/item.maxValue*100)+'%'}"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="qureright-bottom">
            <div style="width:31%">
              <div class="chartslength">
                <div class="chartslength-title">
                  <div style="margin-bottom:12px;">在织订单跟踪</div>
                  <div></div>
                </div>
                <div class="lengthitem">
                  <div>
                    <div v-for="(item,i) in ordersInWoven" :key="i">
                      <div>
                        <div class="nametip">{{item.wovenName}}</div>
                        <div>{{item.wovenValue}}%</div>
                      </div>
                      <div class="longlength">
                        <div style="background:#FF106E" :style="{width:item.wovenValue+'%'}"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div style="width:31%">
              <div class="chartslength-title2">
                <div>当日停机时间长机台</div>
                <div class="nametip">
                  <span class="pinknum">{{machineDownTimeSum}}</span> H
                </div>
              </div>
              <div id="myChart1" :style="{height: '270px',margin:'-36px 0 0 0'}"></div>
            </div>
            <div style="width:38%" @mouseover="hovertip1 = true" @mouseout="hovertip1 =false">
              <div class="chartslength-title2" style="position:relative">
                <div>耗电情况测算 ( 度 )</div>
                <div class="nametip">
                  本月
                  <span class="pinknum">{{thisMonthPower}}</span>
                </div>
                <div class="hovertip" v-if="hovertip1" style="right:150px;top:12px">按照2.2kw的功率测算</div>
              </div>
              <div id="myChart2" :style="{height: '270px',margin:'-36px 0 0 0'}"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="chartbottom">
        <div class="chartbottom-left">
          <div>验布</div>
          <div>
            <div>
              <div>今日已检</div>
              <div>
                <div>
                  <span>{{todayTest.amount || 0}}</span>
                  <span>米</span>
                </div>
                <div>
                  <span>{{todayTest.volumeCount || 0}}</span>
                  <span>卷</span>
                </div>
                <div>
                  <span>{{todayCheck.todayFlawTest || 0}}</span>
                  <span>疵点</span>
                </div>
              </div>
            </div>
            <div style="margin-top:-50px;position:relative">
              <div style="position:absolute;right:10px;top:35px">单位：米</div>
              <div id="myChart9" :style="{height: '270px'}"></div>
            </div>
          </div>
          <div>
            <div>
              <div>本月已检</div>
              <div>
                <div>
                  <span>{{thisMonthTest.amount || 0}}</span>
                  <span>米</span>
                </div>
                <div>
                  <span>{{thisMonthTest.volumeCount || 0}}</span>
                  <span>卷</span>
                </div>
                <div>
                  <span>{{thisMonthCheck.thisMonthFlawTest || 0}}</span>
                  <span>疵点</span>
                </div>
              </div>
            </div>
            <div>
              <div>单位：万米</div>
              <div style="position:relative; top:-42px">
                <div id="myChart7" :style="{height: '280px'}"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="chartbottom-right">
          <div class="chartbottom-right-list">
            <div style="width：35%">仓库</div>
            <div>
              <div class="nametip">
                在库品种
                <span class="pinknum">{{findStoreStatus.productCount}}</span>
              </div>
              <div class="nametip">
                在库卷数
                <span class="pinknum">{{findStoreStatus.allVolume}}</span>
              </div>
              <div class="nametip">
                米数(万米)
                <span class="pinknum">{{findStoreStatus.allAmount}}</span>
              </div>
            </div>
          </div>
          <div>
            <div class="chartbottom-right-tip">
              <div style="font-size:22px">本月入库</div>
              <div>
                <div>
                  <div>{{inNumAndVolumn.volume || 0}}</div>
                  <div class="nametip">卷数</div>
                </div>
                <div>
                  <div>{{inNumAndVolumn.outInNum || 0}}</div>
                  <div class="nametip">米数(万米)</div>
                </div>
              </div>
            </div>
            <div>
              <div style="position:absolute;right:20px;top:-10px;" class="nametip">单位：万米</div>
              <div id="myChart3" :style="{height: '270px',margin:'-36px 0 0 0'}"></div>
            </div>
          </div>
          <div>
            <div class="chartbottom-right-tip">
              <div style="font-size:22px">本月出库</div>
              <div>
                <div>
                  <div>{{outNumAndVolumn.volume || 0}}</div>
                  <div class="nametip">卷数</div>
                </div>
                <div>
                  <div>{{outNumAndVolumn.outInNum || 0}}</div>
                  <div class="nametip">米数(万米)</div>
                </div>
              </div>
            </div>
            <div>
              <div style="position:absolute;right:20px;top:-10px;" class="nametip">单位：万米</div>
              <div id="myChart4" :style="{height: '270px',margin:'-36px 0 0 0'}"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  name: "Digitalfactorydata",
  data() {
    return {
      hovertip1: false,
      hovertip2: false,
      hovertip3: false,
      week: ["日", "一", "二", "三", "四", "五", "六"],
      Laydata: ["1", "2", "3", "4", "5", "6", "7", "2", "3", "4", "6", "7", "2", "3", "4", "5", "6", "7", "2", "3", "4", "5", "6", "7", "2", "3", "4", "5", "6", "7", "2", "3", "4", "5", "6", "7", "2", "3", "4", "5", "6", "7"], //当日了机预测日历
      areaStyle: {
        change: {
          color: {
            type: "linear",
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: "#4466F4" // 0% 处的颜色
              },
              {
                offset: 1,
                color: "transparent" // 100% 处的颜色
              }
            ],
            global: false // 缺省为 false
          }
        },
        normal: {
          opacity: 0.1,
          color: "#4466F4"
        },
        none: {
          color: "transparent"
        }
      }, //折线图 面积样式 种类
      maxmin: {
        //柱状图 最大值最小值
        min: 0,
        max: 100
      },
      currentdate: "", //时间
      lastmonday: "", //上个月还剩几天显示在当月日历上
      lastmondate: "", //上个月最后一天是多少号
      nextmonday: "", //下个月几天显示在当月日历上
      todaynum: "", //当前多少号

      thisMontyYield: "", //当月产量
      todayYield: "", //当日产量
      monthlyCapacity: "", //月产能

      findEfficiency: "", //rateOfDay 当日效率  rateOfMonth 当月效率   knittingOrders 在织订单

      todayYieldOfVariety: "", //当日品种产量

      ordersInWoven: "", //在织机台跟踪

      findStoreStatus: "", // 查询仓库库存状况 右下角横 allAmount剩余长度 allVolume 剩余卷数 productCount 剩余种类数

      thisMonthCheck: "", //当月验布状态 瑕疵点
      thisMonthTest: "", //当月验布状态 卷数 米数
      todayCheck: "", //今日验布状态 瑕疵点
      todayTest: "", //今日验布状态 米数 卷数

      percendata: ["95%-100%", "90%-95%", "80%-90%", "低于80%"], // 0:95%-100% 1:90%-95% 2:80%-90% 3:低于80%
      efficiencyGroup: "", //当日机台效率区间 值
      machineDownTimeSum: "", //当日停机时长
      getCallCount: "", //机修呼叫、上轴呼叫、落布呼叫
      getMachineStatusdata: "", //查询总机台数、异常机台数、在织订单
      inNumAndVolumn: "", //本月入库
      outNumAndVolumn: "", //本月出库
      thisMonthPower: "", //耗电情况 本月
      getTitle: "", //公司名称

      settime1: "",
      settime2: "",
      settime3: "",
      settime4: "",
      settime5: "",

      urlParam:{}
    };
  },
  mounted() {
    var url = window.location.href ;             //获取当前url
    
      var dz_url = url.split('#')[0];                //获取#/之前的字符串
      var cs = decodeURIComponent(dz_url.split('?')[1]);                //获取?之后的参数字符串
      var cs_arr = cs.split('&');                    //参数字符串分割为数组
      this.urlParam={};
      for(var i=0;i<cs_arr.length;i++){         //遍历数组，拿到json对象
        this.urlParam[cs_arr[i].split('=')[0]] = cs_arr[i].split('=')[1]
      }
      console.log(this.urlParam);
    // console.log($(window).height())
    // $('.benq-fit').css('height',($(window).height()-70)+'px');
    // 在织机台跟踪 暂不刷新
    this.$axios({
      method: "post",
      headers:{
        token:this.urlParam.token
      },
      url: "/dataStatistic/ordersInWoven"
    })
      .then(res => {
        // console.log(res.data.ordersInWoven);
        this.ordersInWoven = res.data.ordersInWoven;
      })
      .catch(error => {
        console.log(error);
      });

    // 公司名
    this.$axios({
      method: "post",
      headers:{
        token:this.urlParam.token
      },
      url: "/dataStatistic/getTitle"
    })
      .then(res => {
        // console.log(res.data);
        this.getTitle = res.data.title;
      })
      .catch(error => {
        console.log(error);
      });

    //获取当日产量 本月产量 月产能  当日效率 本月效率 在织订单 当日机台效率区间 当班员工效率排名 当日停机长的机台
    //在库品种在库卷数米数(查询仓库库存状况) 今日已检 本月已检 本月入库 本月出库  当日品种产量 5minutes 刷新
    this.getTodayinfo();
    //机修呼叫、上轴呼叫、落布呼叫   1minute
    this.getDataDictionary();
    // 获取时间
    this.getDatatime();
    // 查询总机台数、异常机台数、在织订单 5second
    this.getMachineStatus();
    //15天验布 本12月验布 6个月入库 6个月出库 下面四个图表 近15日效率趋势、产量趋势、耗电量趋势 了机预测 2hous 刷新
    this.getTmouthdata();
  },
  created() {
    //  计时器
    // 2hous
    this.settime1 = setInterval(() => {
      this.getTmouthdata();
    }, 1000 * 60 * 60 * 2);
    // 5minutes
    this.settime2 = setInterval(() => {
      this.getTodayinfo();
    }, 1000 * 60 * 5);
    // 5second
    this.settime3 = setInterval(() => {
      this.getMachineStatus();
    }, 1000 * 5);
    // 1minute
    this.settime4 = setInterval(() => {
      this.getDataDictionary();
    }, 1000 * 60);
    // 时间
    this.settime5 = setInterval(() => {
      this.getDatatime();
    }, 1000);
  },
  destroyed() {
    // （很重要）当跳转到其他页面的时候，要在生命周期的destroyed里清空this.cdTimer，不然会出错
    clearTimeout(this.settime1);
    clearTimeout(this.settime2);
    clearTimeout(this.settime3);
    clearTimeout(this.settime4);
    clearTimeout(this.settime5);
  },
  methods: {
    // 正常运转机台数/总机台数
    // 数据测算最大理论月产能
    // 按照2.2kw的功率测算
    getUrlParam(){
      
    },
    //15天验布 本12月验布 6个月入库 6个月出库 下面四个图表 近15日效率趋势、产量趋势、耗电量趋势 了机预测 2hous 刷新
    getTmouthdata() {
      // 最近15天的验布状况
      this.$axios({
        method: "post",
        headers:{
          token:this.urlParam.token
        },       
        url: "/dataStatistic/recently15DayCheck"
      })
        .then(res => {
          // console.log(res.data.recently15DaysTestList);
          var amount = [];
          var day = [];
          for (
            var i = res.data.recently15DaysTestList.length - 1;
            i >= 0;
            i--
          ) {
            day.push(res.data.recently15DaysTestList[i].day.slice(5, 10));
            amount.push(res.data.recently15DaysTestList[i].amount);
          }
          // console.log(day, amount);
          // 今日已检  柱状图表
          this.Getbarcanvas("myChart9", "#FF106E", day, amount, "", 0);
        })
        .catch(error => {
          console.log(error);
        });
      // 最近12月的验布状况
      this.$axios({
        method: "post",
        headers:{
          token:this.urlParam.token
        },
        url: "/dataStatistic/recently12MonthCheck"
      })
        .then(res => {
          // console.log(res.data.recently12MonthTestList);
          var arryx = [];
          var arryy = [];
          for (
            var i = res.data.recently12MonthTestList.length - 1;
            i >= 0;
            i--
          ) {
            arryy.push(res.data.recently12MonthTestList[i].amount);
            arryx.push(res.data.recently12MonthTestList[i].month);
          }
          // console.log(arryy, arryx);
          // 本月已检
          this.Getlinecanvas(
            "myChart7",
            "#4466F4",
            "",
            this.areaStyle.none,
            "1",
            arryx,
            arryy,
            true
          );
        })
        .catch(error => {
          console.log(error);
        });
      // 最近6月的出库状况
      this.$axios({
        method: "post",
        headers:{
          token:this.urlParam.token
        },
        url: "/dataStatistic/findOutStoreNum"
      })
        .then(res => {
          // console.log(res.data.recentlyOutNum);
          var arry1 = [];
          var arry2 = [];
          for (var i = res.data.recentlyOutNum.length - 1; i >= 0; i--) {
            arry2.push(res.data.recentlyOutNum[i].outInNum);
            arry1.push(res.data.recentlyOutNum[i].outInDate);
          }
          // console.log(arry2, arry1);
          // 本月出库
          this.Getlinecanvas(
            "myChart4",
            "#FF106E",
            "smooth:true",
            this.areaStyle.none,
            "0",
            arry1,
            arry2,
            true
          );
        })
        .catch(error => {
          console.log(error);
        });
      // 最近6月的入库状况
      this.$axios({
        method: "post",
        headers:{
          token:this.urlParam.token
        },
        url: "/dataStatistic/findInStoreNum"
      })
        .then(res => {
          // console.log(res.data.recentlyInNum);
          var outInDate = [];
          var outInNum = [];
          for (var i = res.data.recentlyInNum.length - 1; i >= 0; i--) {
            outInNum.push(res.data.recentlyInNum[i].outInNum);
            outInDate.push(res.data.recentlyInNum[i].outInDate);
          }
          // console.log(outInNum, outInDate);
          //本月入库
          this.Getlinecanvas(
            "myChart3",
            "#4466F4",
            "",
            this.areaStyle.normal,
            "0",
            outInDate,
            outInNum,
            true
          );
        })
        .catch(error => {
          console.log(error);
        });
      // 近15日效率趋势、产量趋势、耗电量趋势
      this.$axios({
        method: "post",
        headers:{
          token:this.urlParam.token
        },
        url: "/dataStatistic/recently15DayEfficiency"
      })
        .then(res => {
          // console.log(res.data);

          this.thisMonthPower = res.data.thisMonthPower;
          var rateseries = [];
          var workTimeTotalseries = [];
          var yieldseries = [];
          var dayseries = [];
          for (
            var i = res.data.recently15DaysRateAndYieldList.length - 1;
            i >= 0;
            i--
          ) {
            rateseries.push(res.data.recently15DaysRateAndYieldList[i].rate);
            workTimeTotalseries.push(
              res.data.recently15DaysRateAndYieldList[i].workTimeTotal
            );
            yieldseries.push(res.data.recently15DaysRateAndYieldList[i].yield);
            dayseries.push(
              res.data.recently15DaysRateAndYieldList[i].day.slice(5, 10)
            );
          }
          // 耗电情况
          this.Getlinecanvas(
            "myChart2",
            "#FF106E",
            "smooth:true",
            this.areaStyle.none,
            "0",
            dayseries,
            workTimeTotalseries,
            false
          );
          // 近15日效率趋势
          this.Getlinecanvas(
            "myChart5",
            "#4466F4",
            "",
            this.areaStyle.change,
            "1",
            dayseries,
            rateseries,
            true,
            this.maxmin
          );
          // 近15日产量趋势
          this.Getlinecanvas(
            "myChart6",
            "#4466F4",
            "smooth:true",
            this.areaStyle.change,
            "1",
            dayseries,
            yieldseries,
            true
          );
        })
        .catch(error => {
          console.log(error);
        });

      // 绘制当月了机预测日历
      this.$axios({
        method: "post",
        headers:{
          token:this.urlParam.token
        },
        url: "/dataStatistic/machineDownForeccast"
      })
        .then(res => {
          // console.log(res.data.endTimeOfMachineList);
          if (res.data.isSuccessed == true) {
            this.Laydata = [];
            // 塞入上个月剩余在当前月份日历天数
            if (this.lastmonday > 0) {
              for (var i = this.lastmonday; i > 0; i--) {
                var item = {
                  endTime: "0" + this.lastmondate - i + 1,
                  endNum: "last"
                };

                this.Laydata.push(item);
              }
            }
            // 塞入当前月份内容
            this.Laydata = this.Laydata.concat(res.data.endTimeOfMachineList);
            // parseInt(tag.endNum)< parseInt(todaynum)
            // 塞入下个月前几天在当前月份日历上天数
            if (this.nextmonday > 0) {
              for (var i = 0; i < this.nextmonday; i++) {
                var item = {
                  endTime: "0" + (i + 1),
                  endNum: "last"
                };

                this.Laydata.push(item);

                // console.log(this.Laydata)
              }
            }
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    //获取当日产量 本月产量 月产能  当日效率 本月效率 在织订单 当日机台效率区间 当班员工效率排名 当日停机长的机台
    //在库品种在库卷数米数(查询仓库库存状况) 今日已检 本月已检 本月入库 本月出库 当日品种产量 5minutes 刷新
    getTodayinfo() {
      //当日品种产量
      this.$axios({
        method: "post",
        headers:{
          token:this.urlParam.token
        },
        url: "/dataStatistic/todayProductYield"
      })
        .then(res => {
          // console.log(res.data);
          (this.todayYieldOfVariety = []),
            (this.todayYieldOfVariety = res.data.todayYieldOfVariety);
          var meternew = 0;
          for (var i = 3; i < this.todayYieldOfVariety.length; i++) {
            $(".scrollbetter").animate(
              {
                "margin-top": meternew + "px"
              },
              3000
            );
            meternew = meternew - 48.1;
            // console.log(meternew);
          }
        })
        .catch(error => {
          console.log(error);
        });
      // 当日产量 本月产量 月产能
      this.$axios({
        method: "post",
        headers:{
          token:this.urlParam.token
        },
        url: "/dataStatistic/yield"
      })
        .then(res => {
          // console.log(res.data);
          this.thisMontyYield = res.data.thisMontyYield.totalNum; //月产量
          this.todayYield = res.data.todayYield.totalNum; //日产量
          this.monthlyCapacity = res.data.monthlyCapacity; //月产能
        })
        .catch(error => {
          console.log(error);
        });
      // 当日效率 本月效率 在织订单
      this.$axios({
        method: "post",
        headers:{
          token:this.urlParam.token
        },
        url: "/dataStatistic/findEfficiency"
      })
        .then(res => {
          // console.log(res.data);
          this.findEfficiency = res.data; //rateOfDay 当日效率  rateOfMonth 当月效率   knittingOrders 在织订单
        })
        .catch(error => {
          console.log(error);
        });

      //当日机台效率区间
      this.$axios({
        method: "post",
        headers:{
          token:this.urlParam.token
        },
        url: "/dataStatistic/efficiencyGroup"
      })
        .then(res => {
          // console.log(res.data.sumLoomDownCount);
          // 0:95%-100% 1:90%-95% 2:80%-90% 3:低于80%
          this.efficiencyGroup = res.data;
        })
        .catch(error => {
          console.log(error);
        });

      // 当班员工效率排名
      this.$axios({
        method: "post",
        headers:{
          token:this.urlParam.token
        },
        url: "/dataStatistic/todayEmpEfficiency"
      })
        .then(res => {
          // console.log(res.data.todayRateOfEmp);

          var name = [];
          var rate = [];
          for (var i = 0; i < res.data.todayRateOfEmp.length; i++) {
            name.push(res.data.todayRateOfEmp[i].name);
            rate.push(res.data.todayRateOfEmp[i].rate);
          }
          // console.log(rate, name);

          //  柱状图
          this.Getbarcanvas(
            "myChart8",
            "#FF106E",
            name,
            rate,
            this.maxmin,
            100
          );
        })
        .catch(error => {
          console.log(error);
        });

      //当日停机长的机台
      this.$axios({
        method: "post",
        headers:{
          token:this.urlParam.token
        },
        url: "/dataStatistic/machineDownTime"
      })
        .then(res => {
          // console.log(res.data.sum);
          this.machineDownTimeSum = res.data.sum;

          var Name = [];
          var shutDownTime = [];
          for (var i = 0; i < res.data.shutDownTime.length; i++) {
            Name.push(res.data.shutDownTime[i].Name);
            shutDownTime.push(res.data.shutDownTime[i].shutDownTime);
          }
          // console.log(shutDownTime,Name)

          // 当日停机长的机台 柱状图
          this.Getbarcanvas("myChart1", "#4466F4", Name, shutDownTime, "", 0);
        })
        .catch(error => {
          console.log(error);
        });

      // 查询仓库库存状况  右下角横着一条三个数据
      this.$axios({
        method: "post",
        headers:{
          token:this.urlParam.token
        },
        url: "/dataStatistic/findStoreStatus"
      })
        .then(res => {
          // console.log(res.data.allVolumn_Amount_ProductTypeNum);
          // "allAmount":0.3643,//剩余长度（万米） allVolume":28,//剩余卷数 productCount":9//剩余种类数
          this.findStoreStatus =
            res.data.allVolumn_Amount_ProductTypeNum;
        })
        .catch(error => {
          console.log(error);
        });

      // 当月验布状态 本月已检
      this.$axios({
        method: "post",
        headers:{
          token:this.urlParam.token
        },
        url: "/dataStatistic/thisMonthCheck"
      })
        .then(res => {
          // console.log(res.data);

          this.thisMonthCheck = res.data;
          this.thisMonthTest = res.data.thisMonthTest;
        })
        .catch(error => {
          console.log(error);
        });

      //今日验布状态 今日已检
      this.$axios({
        method: "post",
        headers:{
          token:this.urlParam.token
        },
        url: "/dataStatistic/todayCheck"
      })
        .then(res => {
          // console.log(res.data);

          this.todayCheck = res.data;
          this.todayTest = res.data.todayTest;
        })
        .catch(error => {
          console.log(error);
        });

      //本月入库 本月出库
      this.$axios({
        method: "post",
        headers:{
          token:this.urlParam.token
        },
        url: "/dataStatistic/findThisMonthOutInStoreNum"
      })
        .then(res => {
          // console.log(res.data);

          this.inNumAndVolumn = res.data.inNumAndVolumn;
          this.outNumAndVolumn = res.data.outNumAndVolumn;
        })
        .catch(error => {
          console.log(error);
        });
    },
    //机修呼叫、上轴呼叫、落布呼叫  1minute
    getDataDictionary() {
      this.$axios({
        method: "post",
        headers:{
          token:this.urlParam.token
        },
        url: "/dataStatistic/getCallCount"
      })
        .then(res => {
          console.log(res.data);
          this.getCallCount = res.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 查询总机台数、异常机台数、在织订单 5second
    getMachineStatus() {
      // 查询总机台数、异常机台数、在织订单
      this.$axios({
        method: "post",
        headers:{
          token:this.urlParam.token
        },
        url: "/dataStatistic/getMachineStatus"
      })
        .then(res => {
          // console.log(res.data);

          this.getMachineStatusdata = res.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 获取当前时间
    getDatatime() {
      var date = new Date();
      var y = date.getFullYear();
      var MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      var h = date.getHours();
      h = h < 10 ? "0" + h : h;
      var m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      var s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      this.currentdate = y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;

      // console.log(this.currentdate);

      // 获取当前多少号
      this.todaynum = date.getDate();

      // 获取当月一号日期
      var nowmonthoneday = new Date(
        new Date().getTime() - (d - 1) * 24 * 60 * 60 * 1000
      );
      // 获取当月一号星期几 获取上个月还剩几天在日历上
      this.lastmonday = nowmonthoneday.getDay();
      // 获取上个月最后一天日期 是多少号
      this.lastmondate = new Date(
        new Date().getTime() - d * 24 * 60 * 60 * 1000
      ).getDate();

      // 获取当月最后一天日期 星期几  剩几天
      date.setMonth(MM);
      date.setDate(0);
      /* 返回当月的天数 */
      var nowmonthdays = date.getDate();
      // 获取最后一天日期
      var nowmonthlastday = new Date(
        new Date().getTime() + (nowmonthdays - d) * 24 * 60 * 60 * 1000
      );
      this.nextmonday = 6 - nowmonthlastday.getDay();

      // console.log(
      //   this.lastmondate,
      //   this.lastmonday,
      //   this.nextmonday,
      //   this.todaynum
      // );
    },
    // 折线图
    Getlinecanvas(
      item,
      color,
      smooth,
      areaStyle,
      triggerwidth,
      arryX,
      arryY,
      ifno,
      maxmin
    ) {
      //1.图表id 2.图表颜色 3.是否平滑 4.是否有面积 5.提示框要不要竖线(线的粗细) 6.X轴标签 7.y轴数据  8.是否显示数值 9.最大值最小值

      //  console.log(
      //      arryX,
      //      arryY
      //     );

      let myChart = this.$echarts.init(document.getElementById(item));
      // 绘制图表
      myChart.setOption({
        // 提示框
        tooltip: {
          trigger: "axis", // 触发类型，默认数据触发，见下图，可选为：'item' ¦ 'axis'
          backgroundColor: "rgba(0,0,0,0.8)", // 提示背景颜色，默认为透明度为0.7的黑色
          // 接受数组分别设定上右下左边距，同css
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "line", // 默认为直线，可选为：'line' | 'shadow'
            lineStyle: {
              // 直线指示器样式设置
              color: "#4466F4",
              width: triggerwidth,
              type: "solid"
            }
          }
          // textStyle: {
          //   color: "#fff"
          // }
        },

        // 是否缩放
        // dataZoom: [
        //   {
        //     type: "inside"
        //   }
        // ],
        // 网格
        grid: { x: 60, y: 60, x2: 25, y2: 60 },
        xAxis: {
          show: true,
          // boundaryGap: false,//x轴是否贴边
          type: "category",
          name: "",
          // 坐标轴线
          axisLine: {
            show: true,
            lineStyle: {
              color: "#181C40",
              width: 1
            }
          },
          // 坐标轴标签
          axisTick: {
            show: false
          },
          // 坐标轴标签
          axisLabel: {
            margin: 16,
            color: "#8495C2",
            fontSize: 12
            // fontStyle: "normal",
            // align: "left",
          },
          data: arryX
        },
        yAxis: {
          maxmin,
          type: "value",
          // 坐标轴在 grid 区域中的分隔线。
          splitLine: {
            // show: true,
            // 背景线
            lineStyle: {
              color: "#181C40",
              width: 1
              // opacity: 1
            }
          },
          // 坐标轴线 y
          axisLine: {
            show: false
          },
          // 坐标轴标签 y
          axisTick: {
            show: false
          },
          // 坐标轴标签
          axisLabel: {
            show: true,
            margin: 20,
            // interval: 2,
            color: "#8495C2",
            align: "center"
            // verticalAlign: "center"
          }
          // splitNumber: 3
        },
        series: [
          {
            data: arryY,
            type: "line",
            label: {
              show: ifno,
              //  position:[0,-15],
              // align:'center'
              distance: 15,
              rotate: 50
            },
            smooth, //是否平滑
            areaStyle
            // symbol:'none', 拐弯点
          }
        ],
        lineStyle: {
          color: color
        },
        // 拐点设置
        itemStyle: {
          color: color
        }
      });
    },
    // 柱状图
    Getbarcanvas(item, sColor, xarry, yarry, maxmin, top) {
      // 绑定图表id  颜色  x轴 y轴 最大值最小值  最大值显示
      let myChart = this.$echarts.init(document.getElementById(item));
      // var yMax = 500;
      var dataShadow = [];

      var alltop = 0;
      for (var i = 0; i < yarry.length; i++) {
        if (yarry[i] > alltop) {
          alltop = yarry[i];
        }
      }
      // console.log(alltop)
      if (top != 100) {
        top = alltop;
      }

      myChart.setOption({
        // 提示框
        tooltip: {
          show: true, // 是否显示提示框，默认为true
          trigger: "item", // 数据项图形触发
          axisPointer: {
            // 指示样式
            type: "shadow",
            axis: "auto"
          },
          padding: 5,
          textStyle: {
            // 提示框内容的样式
            color: "#fff"
          }
        },

        // 网格
        grid: { x: 50, y: 60, x2: 25, y2: 60 },
        xAxis: {
          data: xarry,
          axisLine: {
            show: true,
            lineStyle: {
              color: "#181C40",
              width: 1
            }
          },
          // 坐标轴标签
          axisTick: {
            show: false
          },
          // 坐标轴标签
          axisLabel: {
            margin: 20,
            color: "#8495C2",
            fontSize: 12,
            rotate: 40, //倾斜角度
            align: "middle"
          }
        },
        yAxis: {
          maxmin,
          // interval:[0,25,50,75,100],
          // splitNumber: 4,
          axisLine: {
            show: false
          },

          splitLine: {
            // 背景线
            lineStyle: {
              color: "#181C40",
              width: 1
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            textStyle: {
              color: "#8495C2"
            }
          }
        },
        // dataZoom: [
        //   {
        //     type: "inside"
        //   }
        // ],
        series: [
          {
            stack: "chart",
            z: 3,
            // For shadow
            // name: "效率",
            type: "bar",
            itemStyle: {
              color: sColor,
              barBorderRadius: 20
            },
            barWidth: 8,
            data: Object.keys(yarry).map(function(key) {
              return yarry[key];
            })
          },
          {
            type: "bar",
            stack: "chart",
            silent: true,
            itemStyle: {
              normal: {
                color: "#181C40",
                barBorderRadius: 20
              }
            },
            barGap: "-100%",
            barCategoryGap: "40%",
            data: Object.keys(yarry).map(function(key) {
              return top - yarry[key];
            }),

            barWidth: 8
          }
        ]
      });

      // Enable data zoom when user click bar.
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='scss' scoped type='text/css'>
.content {
  width: 100%;
  min-width: 1800px;
  background: #090918;
  min-height: 1000px;
  font-size: 20px;
  .title {
    display: flex;
    justify-content: space-between;
    padding: 0 20px;
    height: 80px;
    line-height: 80px;
    background: #0f122d;
    font-size: 25px;
    align-items: center;
    img {
      width: 60px;
      margin-top: 30px;
    }
    .time {
      line-height: 25px;
      > div:first-child {
        font-size: 18px;
        background: #181c40;
        padding: 3px 15px;
        border-radius: 20px;
        margin-bottom: 5px;
      }
      > div:nth-child(2) {
        font-size: 16px;
        color: #8495c2;
        float: right;
        margin-right: 10px;
      }
    }
  }
  .hightcontent {
    padding: 15px;
    .nametip {
      font-size: 14px;
      color: #8495c2;
      display: flex;
      align-items: center;
    }
    .hight36 {
      padding-top: 0.9% !important;
    }
    .hovertip {
      font-size: 13px;
      background: #090918;
      opacity: 0.8;
      padding: 20px 20px;
      position: absolute;
      right: -90px;
      border-radius: 6px;
      top: 80px;
    }
    .hovertitle {
      width: 20px;
      height: 20px;
      display: inline-block;
      line-height: 20px;
      text-align: center;
      background: #090918;
      opacity: 0.9;
      border-radius: 10px;
      margin-left: 5px;
      color: white;
      font-size: 14px;
      cursor: pointer;
    }
    .pinknum {
      color: #ff106e;
      font-size: 20px;
      margin: 0 5px;
      display: flex;
      align-items: center;
    }
    .series {
      background: #0f122d;
      height: 68px;
      margin-bottom: 15px;
      padding: 30px 0;
      display: flex;
      > div:first-child {
        padding-left: 0px;
      }
      > div {
        display: flex;
        width: 22%;
        padding: 0 20px;
        text-align: left;
        > div {
          width: 32%;
          font-size: 25px;
          // padding-left: 4%;
        }
        > div:first-child {
          padding-left: 6%;
        }
      }
      > div:not(:last-child) {
        border-right: 1px solid #4466f4;
      }
      .serieslay {
        > div {
          > div:first-child {
            margin-bottom: 12px;
          }
          > div:nth-child(2),
          .danmi {
            color: #8495c2;
            font-size: 20px;
          }
        }
      }
      .seriesshow {
        width: 28%;
        > div {
          display: flex;
          align-items: center;
          padding-left: 35px;
          > div:first-child {
            width: 65px;
            height: 65px;
            line-height: 65px;
            text-align: center;
            border: 1px solid #4466f4;
          }
          > div:nth-child(2) {
            color: #8495c2;
            font-size: 20px;
            margin-left: 12px;
            > div:first-child {
              margin-bottom: 12px;
            }
          }
        }
      }
    }
    .chartstop {
      display: flex;
      margin-bottom: 15px;
      .qureleft {
        width: 24%;
        margin-right: 15px;
        .daylay {
          color: #8495c2;
          font-size: 14px;
          > div:first-child {
            display: flex;
            > div {
              width:calc(100% / 7);
              height: 45px;
              line-height: 45px;
              text-align: center;
             // border:1px solid red;
            }
          }
          > div:nth-child(2) {
            display: flex;
            flex-wrap: wrap;
            height: 305px;
             //background:red;
            > div {
             width: calc((100% - 4px) / 7);
              padding-top: 2%;
              // height: 17.5%;
              text-align: center;
              border-bottom: 0.5px solid #181c40;
              border-right: 0.5px solid #181c40;
            }
            .detailsnum {
              background: #4466f4;
              border-radius: 15px;
              color: #fff;
              font-size: 12px;
              display: inline-block;
              margin-top: 6%;
              padding: 0px 2.5px;
              height: 18px;
              line-height: 18px;
              min-width: 14px;
            }
            > div:nth-child(1),
            > div:nth-child(8),
            > div:nth-child(15),
            > div:nth-child(22),
            > div:nth-child(29),
            > div:nth-child(36) {
              border-left: 0.5px solid #181c40;
            }
            > div:nth-child(1),
            > div:nth-child(2),
            > div:nth-child(3),
            > div:nth-child(4),
            > div:nth-child(5),
            > div:nth-child(6),
            > div:nth-child(7) {
              border-top: 0.5px solid #181c40;
            }
          }
        }
        > div {
          .cerclecanvans {
            display: flex;
            flex-wrap: wrap;
            margin-top: 20px;
            > div > div:first-child >>> svg path:first-child {
              stroke: #090918;
            }
            > div:nth-child(2),
            > div:nth-child(4) {
              margin-left: 10%;
            }
            > div {
              width: 26%;
              // border: 1px solid white;
              height: 170px;
              padding: 0 9%;
              position: relative;
              .el-progress__text {
                position: absolute;
                text-align: center;
                top: 20%;
                left: 33%;
                width: 60px;
                height: 60px;
                // border: 1px solid red;
              }
              > div:nth-child(2) {
                color: #8495c2;
                margin-top: 15px;
                text-align: center;
              }
            }
          }
        }

        > div {
          background: #0f122d;
        }
        > div:first-child {
          margin-bottom: 15px;
          padding: 25px;
          height: 345px;
        }
        > div:nth-child(2) {
          padding: 20px 25px;
          height: 375px;
        }
      }
      .qureright {
        width: 76%;
        .chartslength-title2 {
          display: flex;
          justify-content: space-between;
          padding: 25px 25px 0px;
        }
        .chartslength {
          padding: 25px;
          .chartslength-title,
          .lengthitem > div > div > div:first-child {
            display: flex;
            justify-content: space-between;
            padding: 0 3px;
          }
          .lengthitem > div > div {
            font-size: 18px;
            font-family: "DINCond";
            margin-bottom: 18px;
          }
          .longlength {
            height: 5px;
            margin-top: 5px;
            background: #181c40;
            border-radius: 5px;
            position: relative;
            > div {
              height: 5px;
              position: absolute;
              top: 0;
              left: 0;
              width: 80%;
              background: #4466f4;
              border-radius: 5px;
            }
          }
        }
        > div {
          display: flex;
        }
        .qureright-top {
          margin-bottom: 15px;
          > div:first-child {
            margin-right: 15px;
          }
          > div {
            width: 50%;
            background: #0f122d;
            height: 265px;
          }
        }
        .qureright-center {
          margin-bottom: 15px;
          > div:first-child {
            margin-right: 15px;
          }
          > div {
            width: 50%;
            background: #0f122d;
            height: 265px;
          }
        }
        .qureright-bottom {
          > div {
            width: 33.33%;
            height: 265px;
            background: #0f122d;
          }
          > div:not(:last-child) {
            margin-right: 15px;
          }
        }
      }
    }
    .chartbottom {
      display: flex;
      .chartbottom-right {
        margin-left: 15px;
        > div {
          display: flex;
          > div:first-child {
            width: 35%;
          }
        }
        .chartbottom-right-list {
          padding: 25px 25px 5px 25px;
          > div:nth-child(2) {
            display: flex;
            > div {
              margin-right: 50px;
            }
          }
        }
        .chartbottom-right-tip {
          padding: 35px 0 0 50px;
          > div:nth-child(2) {
            margin-top: 20px;
            display: flex;
            > div > div:first-child {
              margin-bottom: 8px;
            }
            > div:first-child {
              margin-right: 31px;
            }
          }
        }
        > div:not(:first-child) > div:first-child {
          width: 20%;
        }
        > div:not(:first-child) > div:not(:first-child) {
          width: 74%;
          position: relative;
        }
      }
      .chartbottom-left {
        > div:first-child {
          padding: 25px;
          padding-bottom: 0;
        }
        > div:not(:first-child) {
          // border: 1px solid green;
          padding: 10px 10px 15px 40px;
          height: 39%;
          display: flex;
          > div:first-child {
            width: 16%;
            > div:first-child {
              margin-bottom: 25px;
              margin-top: 23px;
              font-weight: bold;
            }
            > div:nth-child(2) {
              > div {
                display: flex;
                align-items: center;
                margin-bottom: 12px;
                > span:first-child {
                  display: inline-block;
                  width: 85px;
                }
                > span:nth-child(2) {
                  font-size: 14px;
                  color: #8495c2;
                }
              }
            }
          }
          > div:nth-child(2) {
            // border: 1px solid red;
            width: 84%;
            > div:first-child {
              font-size: 14px;
              color: #8495c2;
              float: right;
              margin-top: -12px;
              margin-right: 25px;
            }
          }
        }
      }
      > div {
        width: 50%;
        height: 516px;
        background: #0f122d;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Digitalfactorydata.vue